import { render, staticRenderFns } from "./InviteModal.vue?vue&type=template&id=2cc2be97&scoped=true&"
import script from "./InviteModal.vue?vue&type=script&lang=ts&"
export * from "./InviteModal.vue?vue&type=script&lang=ts&"
import style0 from "./InviteModal.vue?vue&type=style&index=0&id=2cc2be97&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc2be97",
  null
  
)

export default component.exports